module.exports = __webpack_public_path__ + "static/img/5.7127758e.jpg";